// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3Z7jJxRTbmQ_xb05G-Tkga","content":"_1tqyD6Ux2F4TZ8e8Agb1_g","details":"_3p5-4ZvjzoadTmrlvc7zsX","info":"_304NI1JdL_npNqxa9T4FIX","title":"_25YrPDelQJByED7wfzp3UJ","description":"_3_ZlOgy12AIHDVWoZSSzN3","images":"Zbf4f2mZwny4sR163OXP2","slider":"_1eWbFfiQ8HGy184G9zaieq","price":"iHUQWb9Z3Fwp7JKCynz3V","viewDetails":"_3rGYrStvEJXKpLgD-ogWvI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyNearbyCell/PropertyNearbyCell.scss
// module id = 785
// module chunks = 0